import { validateNumber } from 'ember-changeset-validations/validators';

export const HomeawayConnectionValidation = {
  newListingPromotionPercentage: validateNumber({
    gt: 0,
    lte: 75,
  }),
};
